export const FAVOURITE_LIST_RECEIVE = "FAVOURITE_LIST_RECEIVE";

export const AFFILIATE_SET_NEW_AFFILIATE = "AFFILIATE_SET_NEW_AFFILIATE";
export const AFIILIATE_LOAD_ERROR = "AFIILIATE_LOAD_ERROR";
export const AFFILIATE_RECEIVE = "AFFILIATE_RECEIVE";

export const CHECKOUT_SET_CUSTOMER_ORDER_NUMBER = "CHECKOUT_SET_CUSTOMER_ORDER_NUMBER";
export const CHECKOUT_SET_DELIVERY_REFERENCE = "CHECKOUT_SET_DELIVERY_REFERENCE";
export const CHECKOUT_SET_DELIVERY_DATE = "CHECKOUT_SET_DELIVERY_DATE";
export const CHECKOUT_SET_GOODS_MARKING = "CHECKOUT_SET_GOODS_MARKING";
export const CHECKOUT_SET_COMPANY_ADDRESSES = "CHECKOUT_SET_COMPANY_ADDRESSES";


export const DOCUMENT_TYPES_RECEIVE = "DOCUMENT_TYPES_RECEIVE";

export const INVOICE_RECEIVE = "INVOICE_RECEIVE";
export const INVOICE_ERROR = "INVOICE_ERROR";
export const INVOICE_CHANGE_MODE = "INVOICE_CHANGE_MODE";
export const INVOICE_SET_INVOICE = "INVOICE_SET_ORDER";
export const INVOICE_CHANGE_CURRENTPAGE = "INVOICE_CHANGE_CURRENTPAGE";

export const PRELIMINARY_ORDER_RECEIVE = "PRELIMINARY_ORDER_RECEIVE";
export const PRELIMINARY_ORDER_ERROR = "PRELIMINARY_ORDER_ERROR";
export const PRELIMINARY_ORDER_CHANGE_MODE = "PRELIMINARY_ORDER_CHANGE_MODE";
export const PRELIMINARY_ORDER_CHANGE_CURRENTPAGE = "PRELIMINARY_ORDER_CHANGE_CURRENTPAGE";
export const PRELIMINARY_ORDER_SET_ORDER = "PRELIMINARY_ORDER_SET_ORDER";

export const QUOTE_RECEIVE = "QUOTE_RECEIVE";
export const QUOTE_ERROR = "QUOTE_ERROR";
export const QUOTE_CHANGE_MODE = "QUOTE_CHANGE_MODE";
export const QUOTE_CHANGE_CURRENTPAGE = "QUOTE_CHANGE_CURRENTPAGE";
export const QUOTE_SET_QUOTE = "QUOTE_SET_QUOTE";

export const SHOPPING_LIST_RECEIVE = "SHOPPING_LIST_RECEIVE";
export const SHOPPING_LIST_ERROR = "SHOPPING_LIST_ERROR";
export const SHOPPING_LIST_CHANGE_MODE = "SHOPPING_LIST_CHANGE_MODE";
export const SHOPPING_LIST_CHANGE_CURRENTPAGE = "SHOPPING_LIST_CHANGE_CURRENTPAGE";
export const SHOPPING_LIST_SET_SHOPPING_LIST = "SHOPPING_LIST_SET_SHOPPING_LIST";

export const USER_RECEIVE = "USER_RECEIVE";
export const USER_ERROR = "USER_ERROR";
export const USER_GROSS_PRICE_TOGGLE = "USER_GROSS_PRICE_TOGGLE";

export const ADDRESS_CHANGE_CURRENTPAGE = "ADDRESS_CHANGE_CURRENTPAGE";
export const ADDRESS_DELETED = "ADDRESS_DELETED";

export const SELECT_ORGANIZATION_RECEIVE = "SELECT_ORGANIZATION_RECEIVE";
export const SELECT_ORGANIZATION_ERROR = "SELECT_ORGANIZATION_ERROR";

export const INCREASE_QTY = "INCREASE_QTY";
export const DECREASE_QTY = "DECREASE_QTY";

export const SILENCIUM_RECEIVE = "SILENCIUM_RECEIVE";
export const SILENCIUM_ERROR = "SILENCIUM_ERROR";

export const VARIANT_ITEMS_SET_MODEL = "VARIANT_ITEMS_SET_MODEL";
export const VARIANT_ITEMS_ERROR = "VARIANT_ITEMS_ERROR";

export const phoneRegExp = /(\+?)\d{2,}/;